module.exports = __webpack_public_path__ + "img/youxi2.5f23c047.png";